import React, {useContext} from "react";
import styled from "@emotion/styled";
import {Link} from "react-router-dom";

import firebase from "firebase/app";
import {UserContext} from "../../contexts/user";
import {ProfileTippy} from "../styled/Tippy";
import {Bars} from "@/components/icons";

const ProfileMenu = ({categories}) => {
  const {user, userDispatch, logout} = useContext(UserContext);

  return (
    <ul>
      {user.isAdmin && (
        <span>
          <li>
            <Link to="/admin">ADMIN</Link>
          </li>
        </span>
      )}
      {user.isEditor && (
        <span>
          <li>
            <Link to="/editor">EDITORS</Link>
          </li>
        </span>
      )}
      {categories.map((category, idx) => (
        <span key={idx}>
          {category.text === "BRAND" ? (
            <>
              {user.isBrand && (
                <li>
                  <Link to={category.href}>{category.text}</Link>
                </li>
              )}
            </>
          ) : (
            <li>
              <Link to={category.href}>{category.text}</Link>
            </li>
          )}
        </span>
      ))}
    </ul>
  );
};

const MobileMenu = ({categories}) => {
  return (
    <ProfileTippy content={<ProfileMenu categories={categories} />} interactive={true}>
      <a className="profile" href="#">
        <Bars />
      </a>
    </ProfileTippy>
  );
};

export default MobileMenu;
